import { useMemo } from 'react';

const NumPad = ({
  value = '',
  onChange,
  allowDecimal = false,
  allowBackspace = true,
  allowClear = true,
  maxLength,
  extraKey,
  className = '',
}) => {
  const keys = useMemo(() => {
    const main = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const bottom = allowDecimal ? ['.', '0'] : [extraKey || '', '0'];
    return [...main, ...bottom];
  }, [allowDecimal, extraKey]);

  const emit = (next) => {
    if (typeof onChange === 'function') onChange(String(next));
  };

  const handleKey = (key) => {
    if (!key) return;
    if (key === '.' && value.includes('.')) return;
    if (maxLength && String(value).length >= maxLength) return;
    emit(`${value}${key}`);
  };

  const handleBackspace = () => {
    if (!value) return;
    emit(String(value).slice(0, -1));
  };

  const handleClear = () => emit('');

  return (
    <div
      className={`grid grid-cols-3 gap-2 select-none ${className}`}
      aria-label="On-screen number pad"
    >
      {keys.map((key, index) => (
        <button
          key={`${key}-${index}`}
          type="button"
          onClick={() => handleKey(key)}
          disabled={!key}
          className={`min-h-[64px] rounded-2xl border border-stone-200 bg-white text-2xl font-semibold text-stone-900 transition active:scale-[0.97] active:bg-stone-100 disabled:opacity-30 ${
            key ? 'hover:bg-stone-50' : ''
          }`}
        >
          {key}
        </button>
      ))}
      <button
        type="button"
        onClick={handleClear}
        disabled={!allowClear || !value}
        className="col-span-1 min-h-[64px] rounded-2xl border border-stone-200 bg-stone-50 text-sm font-semibold uppercase tracking-wide text-stone-600 transition active:scale-[0.97] active:bg-stone-200 disabled:opacity-30"
      >
        Clear
      </button>
      <button
        type="button"
        onClick={handleBackspace}
        disabled={!allowBackspace || !value}
        className="col-span-2 min-h-[64px] rounded-2xl border border-stone-200 bg-stone-50 text-xl font-semibold text-stone-700 transition active:scale-[0.97] active:bg-stone-200 disabled:opacity-30"
        aria-label="Backspace"
      >
        &larr; Back
      </button>
    </div>
  );
};

export default NumPad;
